import React from 'react';

export type TProps = {
  data: {
    title: string;
  };
  template: string;
};

export function Title({ data, template }: TProps) {
  const prefixTemplateClass = `vitrine-template${template}`;

  return (
    <h3
      className={`${prefixTemplateClass}__title`}
      dangerouslySetInnerHTML={{
        __html: data.title,
      }}
    />
  );
}
